import React, { useEffect, useState } from "react";
import EliteLayout from "../../../app-layouts/EliteLayout";
import AdsBanner from "../../../app-layouts/AdsBanner";
import { LuCheck, LuChevronLeft } from "react-icons/lu";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ELITELINKS } from "../../../app-routes/links";
import PaymentButton from "../../../app-util/PayWithPaystack";
import { FaCaretDown } from "react-icons/fa";
import { GOLD } from "../../../assets/img";
import FlutterwavePaymentButton from "../../../app-util/PayWithFlutterwave";
import apiClient from "../../../api-services/ApiClient";
import { FLW_PUBLIC_KEY, getUser } from "../../../api-services/process";
import { UserProfileInterface } from "../../../app-schemas/user.interface";

const Subscriptions = () => {
  const navigate = useNavigate();
  const { id } = useParams() || {};
  console.log(id);
  const user: UserProfileInterface = getUser();
  let country = user?.country?.name;
  let currency = country === 'Nigeria' ? 'NGN' : 'USD';
  const  USD_MONTH = 4;
  const  NGN_MONTH = 5000;

  const config = {
    reference: user?.id + new Date().getTime().toString(),
    email: user?.email,
    name: user?.full_name,
    phone: user?.phone_number,
    amount: 5000,
    publicKey: FLW_PUBLIC_KEY || "",
    currency: currency === "NGN" ? "NGN" : "USD",
    redirect_url: "https://honeconnect.com/flutterwave-callback",
  };

  const [plan, setPlan] = useState(6);
  const [payWith, setPayWith] = useState("flutterwave");

  const availPlans = [
    {
      key: 1,
      value: "Month",
      discount: 0,
    },
    {
      key: 3,
      value: "Quarter",
      discount: 2.5 / 100,
    },
    {
      key: 6,
      value: "Bi-Annual",
      discount: 5 / 100,
    },
    {
      key: 12,
      value: "Year",
      discount: 7.5 / 100,
    },
  ];

  const calculateDiscountedPrice = (
    basePrice: number,
    discount: number | undefined,
  ): number => {
    const finalPrice = basePrice * (1 - (discount ?? 0));
    return Math.round(finalPrice * plan);
  };

  const verifyPayment = async (reference: any) => {
    try {
      const res = apiClient.get(`verify-flutterwave-transaction/${reference}`);
      console.log(await res);
      navigate(ELITELINKS.MY_PAYMENTS);
    } catch (err) {
      console.log(err);
    } finally {
      console.log("closed");
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    const transaction_id = params.get("transaction_id");
    // const tx_ref = params.get("tx_ref");

    if (status === "successful" && transaction_id) {
      verifyPayment(transaction_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <EliteLayout>
      <section className="bg-hc_F4EBFA min-h-[100vh] sm:pt-10 mb-20">
        <div className="grid grid-cols-12 gap-8 justify-between w-full sm:w-11/12 sm:mx-auto">
          <div className="col-span-12 md:col-span-10 bg-hc_F4EBFA min-h-[100vh] dark:bg-slate-700 rounded-10px py-10 sm:px-7">
            <div className="mb-8 hidden sm:block">
              <Link
                to={ELITELINKS.HOME}
                className="text-honeConnectPurple flex items-center font-semibold text-sm"
              >
                <LuChevronLeft />
                <span>Back</span>
              </Link>
            </div>

            <div className="sm:mb-10 mt-8 mb-2 px-4">
              <p className="text-honeConnectBlack dark:text-gray-300 text-xs mt-1">
                Make Payment
              </p>
            </div>

            {/* payment plan section */}
            <div className="flex sm:gap-5 gap-1 px-4 justify-start overflow-hidden">
              <div className="text-center flex flex-col items-center h-full w-1/4">
                <button
                  className={`text-sm py-2 sm:px-4 px-2 dark:bg-slate-800 dark:text-gray-300 dark:border-slate-800 border border-solid border-honeConnectGray200 bg-honeConnectGray50 font-medium text-honeConnectGray rounded-[5px] h-[80px] w-full ${
                    plan === 1 &&
                    "bg-honeConnectPurple dark:bg-honeConnectPurple text-white"
                  }`}
                  onClick={() => {
                    setPlan(1);
                  }}
                >
                  Monthly
                </button>
                {plan === 1 && (
                  <FaCaretDown className="text-3xl text-honeConnectPurple relative top-[-13px]" />
                )}
              </div>

              <div className="text-center flex flex-col items-center h-full w-1/4">
                <button
                  className={`text-sm py-2 sm:px-4 px-2 dark:bg-slate-800 dark:text-gray-300 dark:border-slate-800 border border-solid border-honeConnectGray200 bg-honeConnectGray50 font-medium text-honeConnectGray rounded-[5px] h-[80px] w-full ${
                    plan === 3 &&
                    "bg-honeConnectPurple dark:bg-honeConnectPurple text-white"
                  }`}
                  onClick={() => {
                    setPlan(3);
                  }}
                >
                  Quarterly
                </button>
                {plan === 3 && (
                  <FaCaretDown className="text-3xl text-honeConnectPurple relative top-[-13px]" />
                )}
              </div>

              <div className="text-center flex flex-col items-center h-full w-1/4">
                <button
                  className={`text-sm py-2 sm:px-4 px-2 dark:bg-slate-800 dark:text-gray-300 dark:border-slate-800 border border-solid border-honeConnectGray200 bg-honeConnectGray50 font-medium text-honeConnectGray rounded-[5px] h-[80px] w-full ${
                    plan === 6 &&
                    "bg-honeConnectPurple dark:bg-honeConnectPurple  text-white"
                  }`}
                  onClick={() => {
                    setPlan(6);
                  }}
                >
                  Bi-Annually
                </button>
                {plan === 6 && (
                  <FaCaretDown className="text-3xl text-honeConnectPurple relative top-[-13px]" />
                )}
              </div>

              <div className="text-center flex flex-col items-center h-full w-1/4">
                <button
                  className={`text-sm py-2 sm:px-4 px-2 dark:bg-slate-800 dark:text-gray-300 border dark:border-slate-800 border-solid border-honeConnectGray200 bg-honeConnectGray50 font-medium text-honeConnectGray rounded-[5px] h-[80px] w-full ${
                    plan === 12 &&
                    "bg-honeConnectPurple dark:bg-honeConnectPurple  text-white"
                  }`}
                  onClick={() => {
                    setPlan(12);
                  }}
                >
                  Annually
                </button>
                {plan === 12 && (
                  <FaCaretDown className="text-3xl text-honeConnectPurple relative top-[-13px]" />
                )}
              </div>
            </div>

            {/* make a payment section */}
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-10 md:gap-5 px-4 sm:pt-5">
              {/* naira sub area */}
              {currency === "NGN" && (
                <div className="border border-solid border-honeConnectGray200 bg-honeConnectGray100 rounded-10px hover:border-honeConnectPurple  dark:bg-slate-800 ">
                  <div className="sm:p-2 p-2">
                    <div className="flex gap-1 justify-start sm:justify-center items-center mt-1 sm:mt-11">
                      <p className="font-medium text-honeConnectBlack text-[25px] dark:text-gray-300">
                        Elite
                      </p>
                      <img src={GOLD} className="h-9 hidden" alt="" />
                    </div>

                    <p className="font-normal sm:text-[50px] text-[30px] text-honeConnectBlack dark:text-gray-300 mt-1 sm:mt-8 text-left sm:text-center">
                      {plan !== 1 && (
                        <small className="block text-[18px] line-through">
                          ₦{NGN_MONTH * plan}
                        </small>
                      )}
                      <span className="block">
                        ₦
                        {calculateDiscountedPrice(
                          NGN_MONTH,
                          availPlans?.find((item: any) => item.key === plan)
                            ?.discount,
                        )}
                      </span>
                    </p>
                    <p className="font-normal text-sm text-honeConnectGray  dark:text-gray-400 mt-1 text-left sm:text-center border-b pb-4">
                      Per{" "}
                      {
                        availPlans?.find((item: any) => item.key === plan)
                          ?.value
                      }
                    </p>

                    {/* pay with selection */}
                    <div className="mx-4 px-4 py-2 bg-gray-50 dark:bg-slate-700 dark:text-gray-400 text-gray-700 pb-5 pt-3">
                      <p className="text-sm font-medium relative left-[-25px]">
                        Select payment method
                      </p>
                      <div className="flex justify-start gap-2 mt-2 font-medium">
                        <div>
                          <input
                            className="relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-neutral-300  
                        dark:border-gray-300 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full 
                        before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute 
                        after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary 
                        dark:checked:border-gray-300 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 
                        checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary 
                        dark:checked:after:border-gray-300 checked:after:bg-primary 
                        dark:checked:after:bg-gray-300 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer 
                        hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 
                        focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] 
                        focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary 
                        dark:checked:focus:border-gray-300 checked:focus:before:scale-100 
                        checked:focus:before:shadow-[0px_0px_0px_13px_#7600bc] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_#c8c8c8] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_#c8c8c8]
                        "
                            type="radio"
                            id="flexRadioDefault"
                            checked={payWith === "flutterwave"}
                            onChange={() => {
                              setPayWith("flutterwave");
                            }}
                          />
                        </div>

                        <span>Flutterwave</span>
                      </div>
                      <div className="flex justify-start gap-2 mt-4 font-medium">
                        <div>
                          <input
                            className="relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-neutral-300  
                        dark:border-gray-300 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full 
                        before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute 
                        after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary 
                        dark:checked:border-gray-300 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 
                        checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary 
                        dark:checked:after:border-gray-300 checked:after:bg-primary 
                        dark:checked:after:bg-gray-300 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer 
                        hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 
                        focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] 
                        focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary 
                        dark:checked:focus:border-gray-300 checked:focus:before:scale-100 
                        checked:focus:before:shadow-[0px_0px_0px_13px_#7600bc] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_#c8c8c8] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_#c8c8c8]
                        relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-neutral-300  
                        dark:border-neutralDark before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full 
                        before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute 
                        after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary 
                        dark:checked:border-neutral-500 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 
                        checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary 
                        dark:checked:after:border-neutral-500 checked:after:bg-primary 
                        dark:checked:after:bg-neutral-500 checked:after:content-[''] 
                        checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] 
                        hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 
                        focus:before:scale-100 focus:before:opacity-[0.12] 
                        focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        checked:focus:border-primary dark:checked:focus:border-neutral-500 checked:focus:before:scale-100 
                        checked:focus:before:shadow-[0px_0px_0px_13px_#7600bc] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.3)] 
                        checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.2)] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.2)]"
                            type="radio"
                            id="flexRadioDefault"
                            checked={payWith === "paystack"}
                            onChange={() => {
                              setPayWith("paystack");
                            }}
                          />
                        </div>

                        <span>Paystack</span>
                      </div>
                    </div>

                    {/* action button area */}
                    {payWith === "paystack" && (
                      <PaymentButton
                        amount={calculateDiscountedPrice(
                          NGN_MONTH,
                          availPlans?.find((item: any) => item.key === plan)
                            ?.discount,
                        )}
                        plan="ELITEGOLD"
                        duration={plan}
                        btnLabel={"Subscribe"}
                        currency="NGN"
                      />
                    )}

                    {payWith === "flutterwave" && (
                      <>
                        <FlutterwavePaymentButton
                          amount={calculateDiscountedPrice(
                            NGN_MONTH,
                            availPlans?.find((item: any) => item.key === plan)
                              ?.discount,
                          )}
                          plan="ELITEGOLD"
                          duration={plan}
                          btnLabel={"Subscribe"}
                          currency="NGN"
                        />

                        <form
                          className="hidden"
                          method="POST"
                          action="https://checkout.flutterwave.com/v3/hosted/pay"
                        >
                          <input
                            type="hidden"
                            name="public_key"
                            value={config.publicKey}
                          />
                          <input
                            type="hidden"
                            name="tx_ref"
                            value={config.reference}
                          />
                          <input
                            type="hidden"
                            name="amount"
                            value={config.amount}
                          />
                          <input
                            type="hidden"
                            name="currency"
                            value={config.currency}
                          />
                          <input
                            type="hidden"
                            name="redirect_url"
                            value={config.redirect_url}
                          />
                          <input type="hidden" name="meta[token]" value="54" />
                          <input
                            type="hidden"
                            name="customer[name]"
                            value={config.name}
                          />
                          <input
                            type="hidden"
                            name="customer[email]"
                            value={config.email}
                          />

                          <button
                            type="submit"
                            className="paystack-button paystack-button bg-honeConnectPurple text-white w-full p-3 rounded-lg border-0 text-base mt-4 mb-6 font-medium"
                          >
                            Subscribe
                          </button>
                        </form>
                      </>
                    )}

                    {/* benefits area */}
                    <div className="flex flex-col gap-4 mb-1 sm:mb-12">
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">Enjoy unlimited requests.</p>
                      </div>
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400 hidden">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">Enjoy Priority requests.</p>
                      </div>
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">
                          Phone Exclusion (Privacy) Benefits.
                        </p>
                      </div>
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">
                          Email Exclusion (Privacy) Benefits.
                        </p>
                      </div>
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">Enjoy Unlimited connections.</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* toggle for dollar sub */}
              {currency === "USD" && (
                <div className="border border-solid border-honeConnectGray200 bg-honeConnectGray100 rounded-10px hover:border-honeConnectPurple  dark:bg-slate-800 ">
                  <div className="sm:p-2 p-2">
                    <div className="flex gap-1 justify-start sm:justify-center items-center mt-1 sm:mt-11">
                      <p className="font-medium text-honeConnectBlack text-[25px] dark:text-gray-300">
                        Elite
                      </p>
                      <img src={GOLD} className="h-9 hidden" alt="" />
                    </div>

                    <p className="font-normal sm:text-[50px] text-[30px] text-honeConnectBlack dark:text-gray-300 mt-1 sm:mt-8 text-left sm:text-center">
                      {plan !== 1 && (
                        <small className="block text-[18px] line-through">
                          ${USD_MONTH * plan}
                        </small>
                      )}
                      <span className="block">
                        $
                        {calculateDiscountedPrice(
                          USD_MONTH,
                          availPlans?.find((item: any) => item.key === plan)
                            ?.discount,
                        )}
                      </span>
                    </p>
                    <p className="font-normal text-sm text-honeConnectGray  dark:text-gray-400 mt-1 text-left sm:text-center border-b pb-4">
                      Per{" "}
                      {
                        availPlans?.find((item: any) => item.key === plan)
                          ?.value
                      }
                    </p>

                    {/* pay with selection */}
                    <div className="mx-4 px-4 py-2 bg-gray-50 dark:bg-slate-700 dark:text-gray-400 text-gray-700 pb-5 pt-3">
                      <p className="text-sm font-medium relative left-[-25px]">
                        Select payment method
                      </p>
                      <div className="flex justify-start gap-2 mt-2 font-medium">
                        <div>
                          <input
                            className="relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-neutral-300  
                        dark:border-gray-300 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full 
                        before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute 
                        after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary 
                        dark:checked:border-gray-300 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 
                        checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary 
                        dark:checked:after:border-gray-300 checked:after:bg-primary 
                        dark:checked:after:bg-gray-300 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer 
                        hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 
                        focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] 
                        focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary 
                        dark:checked:focus:border-gray-300 checked:focus:before:scale-100 
                        checked:focus:before:shadow-[0px_0px_0px_13px_#7600bc] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_#c8c8c8] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_#c8c8c8]
                        "
                            type="radio"
                            id="flexRadioDefault"
                            checked={payWith === "flutterwave"}
                            onChange={() => {
                              setPayWith("flutterwave");
                            }}
                          />
                        </div>

                        <span>Flutterwave</span>
                      </div>

                      <div className="flex justify-start gap-2 mt-4 font-medium hidden">
                        <div>
                          <input
                            className="relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-neutral-300  
                        dark:border-gray-300 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full 
                        before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute 
                        after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary 
                        dark:checked:border-gray-300 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 
                        checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary 
                        dark:checked:after:border-gray-300 checked:after:bg-primary 
                        dark:checked:after:bg-gray-300 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer 
                        hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 
                        focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] 
                        focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary 
                        dark:checked:focus:border-gray-300 checked:focus:before:scale-100 
                        checked:focus:before:shadow-[0px_0px_0px_13px_#7600bc] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_#c8c8c8] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_#c8c8c8]
                        relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-neutral-300  
                        dark:border-neutralDark before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full 
                        before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute 
                        after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary 
                        dark:checked:border-neutral-500 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 
                        checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary 
                        dark:checked:after:border-neutral-500 checked:after:bg-primary 
                        dark:checked:after:bg-neutral-500 checked:after:content-[''] 
                        checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] 
                        hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 
                        focus:before:scale-100 focus:before:opacity-[0.12] 
                        focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        checked:focus:border-primary dark:checked:focus:border-neutral-500 checked:focus:before:scale-100 
                        checked:focus:before:shadow-[0px_0px_0px_13px_#7600bc] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.3)] 
                        checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] 
                        dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.2)] 
                        dark:checked:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.2)]"
                            type="radio"
                            id="flexRadioDefault"
                            checked={payWith === "paystack"}
                            onChange={() => {
                              setPayWith("paystack");
                            }}
                          />
                        </div>

                        <span>Paystack</span>
                      </div>
                    </div>

                    {/* action button area */}
                    {payWith === "paystack" && (
                      <PaymentButton
                        amount={calculateDiscountedPrice(
                          USD_MONTH,
                          availPlans?.find((item: any) => item.key === plan)
                            ?.discount,
                        )}
                        plan="ELITEGOLD"
                        duration={plan}
                        btnLabel={"Subscribe"}
                        currency="USD"
                      />
                    )}

                    {payWith === "flutterwave" && (
                      <>
                        <FlutterwavePaymentButton
                          amount={calculateDiscountedPrice(
                            USD_MONTH,
                            availPlans?.find((item: any) => item.key === plan)
                              ?.discount,
                          )}
                          plan="ELITEGOLD"
                          duration={plan}
                          btnLabel={"Subscribe"}
                          currency="USD"
                        />

                        <form
                          className="hidden"
                          method="POST"
                          action="https://checkout.flutterwave.com/v3/hosted/pay"
                        >
                          <input
                            type="hidden"
                            name="public_key"
                            value={config.publicKey}
                          />
                          <input
                            type="hidden"
                            name="tx_ref"
                            value={config.reference}
                          />
                          <input
                            type="hidden"
                            name="amount"
                            value={config.amount}
                          />
                          <input
                            type="hidden"
                            name="currency"
                            value={config.currency}
                          />
                          <input
                            type="hidden"
                            name="redirect_url"
                            value={config.redirect_url}
                          />
                          <input type="hidden" name="meta[token]" value="54" />
                          <input
                            type="hidden"
                            name="customer[name]"
                            value={config.name}
                          />
                          <input
                            type="hidden"
                            name="customer[email]"
                            value={config.email}
                          />

                          <button
                            type="submit"
                            className="paystack-button paystack-button bg-honeConnectPurple text-white w-full p-3 rounded-lg border-0 text-base mt-4 mb-6 font-medium"
                          >
                            Subscribe
                          </button>
                        </form>
                      </>
                    )}

                    {/* benefits area */}
                    <div className="flex flex-col gap-4 mb-1 sm:mb-12">
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">Enjoy unlimited requests.</p>
                      </div>
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400 hidden">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">Enjoy Priority requests.</p>
                      </div>
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">
                          Phone Exclusion (Privacy) Benefits.
                        </p>
                      </div>
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">
                          Email Exclusion (Privacy) Benefits.
                        </p>
                      </div>
                      <div className="flex gap-2 font-normal text-honeConnectGray dark:text-gray-400">
                        <div>
                          <LuCheck className="text-xl" />
                        </div>
                        <p className="text-xs">Enjoy Unlimited connections.</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <AdsBanner></AdsBanner>
        </div>
      </section>
    </EliteLayout>
  );
};

export default Subscriptions;
